import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, Link2Off, RefreshCw } from "lucide-react";
import api from "../../lib/api";
import { errMsg } from "../admin/ui";

export default function TelegramLink({ prefs, onChange }) {
  const [link, setLink] = useState(null);
  const [checking, setChecking] = useState(false);
  const check = async (silent) => {
    setChecking(true);
    try { const r = await api.post("/telegram/link/check"); if (r.data.telegram_linked) { setLink(null); onChange(r.data); if (!silent) toast.success("Telegram terhubung"); } else if (!silent) toast.info("Belum terhubung. Pastikan Anda menekan Start di bot."); }
    catch (e) { if (!silent) toast.error(errMsg(e)); } finally { setChecking(false); }
  };
  useEffect(() => {
    if (!link) return undefined;
    const iv = setInterval(() => check(true), 5000);
    return () => clearInterval(iv);
  }, [link]); // eslint-disable-line react-hooks/exhaustive-deps

  const start = async () => {
    try { const r = await api.post("/telegram/link"); setLink(r.data); window.open(r.data.deep_link, "_blank", "noopener"); } catch (e) { toast.error(errMsg(e)); }
  };
  const unlink = async () => {
    try { const r = await api.post("/telegram/unlink"); onChange(r.data); toast.success("Telegram diputus"); } catch (e) { toast.error(errMsg(e)); }
  };

  if (!prefs.telegram_available) return <div data-testid="tg-unavailable" className="text-xs text-[#A8A8AD]">Bot Telegram belum diaktifkan oleh Owner. Notifikasi website tetap berjalan.</div>;
  if (prefs.telegram_linked) return (
    <div className="flex flex-wrap items-center gap-3">
      <span data-testid="tg-linked" className="text-xs font-bold text-[#35C78A] border border-[#35C78A] rounded-sm px-2 py-1">TERHUBUNG{prefs.telegram_username ? ` · @${prefs.telegram_username}` : ""}</span>
      <button data-testid="tg-unlink-btn" onClick={unlink} className="inline-flex items-center gap-1 text-xs text-[#F06464] hover:underline"><Link2Off size={13} /> Putuskan</button>
    </div>
  );
  return (
    <div className="space-y-2">
      <button data-testid="tg-link-btn" onClick={start} className="inline-flex items-center gap-2 bg-[#229ED9] hover:bg-[#36ade6] text-white font-bold rounded-sm px-4 py-2 text-sm transition-colors"><Send size={14} /> Hubungkan Telegram (@{prefs.bot_username})</button>
      {link && <div data-testid="tg-link-pending" className="text-xs text-[#A8A8AD]">Telegram terbuka di tab baru: tekan <b className="text-[#F5F3ED]">Start</b> di bot. Link berlaku {link.expires_in_minutes} menit.
        <a href={link.deep_link} target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] ml-1 underline">Buka lagi</a>
        <button data-testid="tg-check-btn" onClick={() => check(false)} disabled={checking} className="ml-2 inline-flex items-center gap-1 text-[#D4AF37]"><RefreshCw size={12} className={checking ? "animate-spin" : ""} /> Cek</button></div>}
    </div>
  );
}
